import { createFormControl } from './form-control-fabric'

export class FormValidator {
  /**
   *
   * @param {HTMLFormElement} root
   */
  constructor(root) {
    this.root = root
    this.root.noValidate = 'novalidate'
    this.controls = Array.from(this.root.elements)
      .map((control) => {
        return createFormControl(control)
      })
      .filter((control) => !!control)
    this.root.addEventListener('submit', this.submitHandler.bind(this))
  }
  valid() {
    const invalidFields = this.controls.filter((control) => {
      return control.valid() === false
    })
    const valid = invalidFields.length === 0
    this.controls.forEach((control) => control.style())
    if (!valid) {
      invalidFields[0].element.focus()
    }
    return valid
  }
  submitHandler(event) {
    if (this.valid() === false) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
